//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/BaseImporter.js";
import "../no/ObjectTypeSelector.js";
import "../no/ObjectTypeSelector.js";
let d=[[[0,"CopiousData",1,0],[0,"FileOpenFlag",1,0],[0,"FlattenAssembly",1,0],[0,"GeomFixupTol",1,0],[0,"ImportTo",1,0],[0,"ImportToTeamcenter",1,0],[0,"LayerDefault",1,0],[0,"LayerMask",1,0],[0,"MapViewDep",1,0],[1,"ObjectTypes",0,"ObjectTypeSelector",0],[0,"Optimize",1,0],[0,"SettingsFile",1,0],[0,"SewSurfaces",1,0],[0,"SimplifyGeometry",1,0],[0,"SmoothBSurf",1,0],[0,"SurfTrimTol",1,0]],[[["filename"],"SaveSettings",{},1,0]],[]];
SPLM.IgesImporter = class extends SPLM.BaseImporter{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.IgesImporter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.IgesImporter.ImportToEnum = Object.freeze({
    "WorkPart" : "WorkPart", "NewPart" : "NewPart"});

SPLM.IgesImporter.CopiousDataEnum = Object.freeze({
    "CubicNURBBestfitSpline" : "CubicNURBBestfitSpline", "LinearNURBSpline" : "LinearNURBSpline", "GroupofLines" : "GroupofLines"});

export default SPLM;